import React from 'react';
import { toolTips } from "@indieasy.software/indieasy-engine";
import rolloverTips from "../../../data/rollovertips";

import styled from '@emotion/styled';
import { Cell, Header, HeaderRowNoBorder, LightRowNoBorder, Table, YellowRow } from '../../../components/ReportTables';
import { LightColors } from '../../../light-theme';

const Link = styled.a({ color: LightColors.blue, fontWeight: "bold", textDecoration: "none", cursor: "pointer" });

const createToolTip = (event, title, text, offset) => {
    const rect = event.currentTarget.getBoundingClientRect();
    toolTips.manager.show(
        toolTips.createToolTip(
            rect.left + rect.width / 2,
            rect.top + rect.height / 2 + 10 + (offset || 0),
            {
                style: { width: "300px" },
                title: title,
                text: text,
            }
        )
    );
};



export const StudentGrid = ({ skills, onViewDetail }) => {
    return <Table>
        <thead>
            <HeaderRowNoBorder>
                <Header>SKILL NAME</Header>
                <Header>GUIDED LESSON SCORE</Header>
                <Header>INDEPENDENT PRACTICE PROFICIENCY</Header>
                <Header>PROFICIENCY DATE</Header>
                <Header>TIME ON SKILL</Header>
            </HeaderRowNoBorder>
            <YellowRow><td colSpan={5} /></YellowRow>
        </thead>
        <tbody>
            {skills.map((skill, index) => (
                <LightRowNoBorder>
                    <Cell>
                        <b>{skill.skill}</b>
                    </Cell>
                    <Cell>{skill.guidedLesson}</Cell>
                    <Cell>{skill.independentPractice}</Cell>
                    <Cell>{skill.proficiencyDate}</Cell>
                    <Cell>{skill.time}</Cell>

                </LightRowNoBorder>
            ))}


        </tbody>
    </Table>
}